import React from 'react';
import { CopilotContextType } from './types';

export const CopilotContext = React.createContext<CopilotContextType | null>(null);
